import {Injectable} from '@angular/core';
import {InMemoryDbService} from 'angular-in-memory-web-api';
import {Observable} from 'rxjs';
import {UsersTable} from './fake-db/users.table';
import {ClientMdmTable} from '../core/_fake/fake-server/clientMdm.table';
import {CustomerInfoEcontrcatTable} from '../core/_fake/fake-server/customerInfoEcontrcat.table';
import {ContractTable} from '../core/_fake/fake-server/contract.table';

@Injectable({
    providedIn: 'root',
})
export class FakeAPIService implements InMemoryDbService {
    constructor() {
    }

    /**
     * Create Fake DB and API
     */
    createDb(): {} | Observable<{}> {
        // tslint:disable-next-line:class-name
        const db = {
            // auth module
            users: UsersTable.users,
            clientsMdm: ClientMdmTable.clientsMdm,
            clientsEcontrat: CustomerInfoEcontrcatTable.clientsEcontrat,

        };
        return db;
    }
}
